import { combineReducers } from 'redux';

import consultaDocumentosProduzidos from './consultaDocumentosProduzidos/reducer';

export default combineReducers({
	consultaDocumentosProduzidos,
});
